<template>
  <ValidationProvider
    tag="div"
    :class="className ? className : 'mb-4'"
    rules="required"
    :name="label"
  >
    <b-field
      slot-scope="{ errors, valid }"
      :label="label"
      :type="{ 'is-danger': errors[0], 'is-success': valid }"
      :message="errors"
    >
      <b-autocomplete
        v-model="value"
        clearable
        :disabled="disabled"
        :data="data"
        :placeholder="placeholder"
        :field="field"
        :loading="isFetching"
        @typing="getAsyncData"
        @select="handleSelect"
      >
        <template slot-scope="props">
          <div class="media-content">
            {{ props.option[field] }}
          </div>
        </template>
      </b-autocomplete>
    </b-field>
  </ValidationProvider>
</template>

<script>
import debounce from "lodash/debounce";
import { ValidationProvider } from "vee-validate";

export default {
  name: "AppAutocompleteField",
  components: { ValidationProvider },
  props: {
    resource: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Введите значение",
    },
    selected: {
      type: Object,
      default: null,
    },
    className: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      data: [],
      isFetching: false,
      value: "",
    };
  },
  created() {
    this.value = this.selected?.[this.field] || null;
  },
  methods: {
    handleSelect(option) {
      this.$emit("select", option);
    },
    getAsyncData: debounce(async function (name) {
      if (name?.length <= 2) {
        this.data = [];
        return;
      }
      this.isFetching = true;
      this.$api.fetchData
        .get(`${this.resource}?${this.field}_contains=${name}`)
        .then((data) => {
          this.data = data;
        })
        .catch((error) => {
          this.data = [];
          throw error;
        })
        .finally(() => {
          this.isFetching = false;
        });
    }, 500),
  },
};
</script>
